import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubscribePanelComponent } from './subscribe-panel.component';
import { SubscribeModule } from './subscribe/subscribe.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { RouterModule } from '@angular/router';
@NgModule({
  declarations: [SubscribePanelComponent],
  imports: [
    CommonModule,
    SubscribeModule.configure({'api': '/ubaseline/api', 'agreementsUrl': '/agreements/url'}),
    SharedModule,
    RouterModule
  ],
  exports: [SubscribePanelComponent],})
export class SubscribePanelModule {}
